/* LinksComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./LinksRenderer");

class LinksComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._gameEditor = context.gameEditor;
        this._logFeed = undefined;
        this.getLogs(this._value);
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        if (this._osUpgradeResultEntity) {
            this._osUpgradeResultEntity.on(
                "PropertiesUpdated",
                (this.updateComponent = this.updateComponent.bind(this))
            );
        }
    }

    _registerLogFeedListeners() {
        if (this._logFeed) {
            this._logFeed.on("ElementAdded", (this._onLogAdded = this._onLogAdded.bind(this)));
        }
    }

    _unregisterListeners() {
        if (this._osUpgradeResultEntity) {
            this._osUpgradeResultEntity.removeListener("PropertiesUpdated", this.updateComponent);
        }

        if (this._logFeed) {
            this._logFeed.removeListener("ElementAdded", this._onLogAdded);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        this._logFeed = undefined;
        return prom;
    }

    _onLogAdded(log) {
        this.emit("LogAdded", log);
    }

    /******************************************/
    /* START PUBLIC API METHODS               */
    /******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setLinks(newVal);
        }
    }
    setLinks(newVal) {
        this._value = newVal;
        this.emit("Links", newVal);
    }

    getValue() {
        return this.getLinks();
    }
    getLinks() {
        return this._value;
    }

    getLogs(resultsEntity) {
        if (_.includes(["COMPLETE", "ERROR", "CANCELED"], this._gameEditor._plan.getStatus())) {
            resultsEntity.loadRelatedJobLog({}).then((logs) => {
                let log = _.get(logs, "logs", []);
                this.emit("LogsAdded", log);
            });
        } else {
            _.delay(() => {
                // Temp workaround for potential delay when back end creates job
                resultsEntity
                    .loadRelatedJob({id: true})
                    .then((job) => {
                        if (job) {
                            this._logFeed = job.startJobLogChangeFeed();
                            return this._logFeed.whenInitialized();
                        }
                    })
                    .then(() => {
                        if (this._logFeed) {
                            this._registerLogFeedListeners();
                            this.emit("LogCreated");
                        }
                    });
            }, 200);
        }
    }

    /******************************************/
    /* END PUBLIC API METHODS                 */
    /******************************************/
}

module.exports = LinksComponent;
